import React from 'react';
import { useDispatch } from 'react-redux';

import ImageUpload from '@components/ImageUpload';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchMoodBoardDetails } from '@store/actions/MoodboardAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { MOODBAOD_PRESENTATION_IMAGE_SIZE } from '@/constants/constant';

const MoodBoardItem = ({ moodboardImageList, moodboardId }) => {
	const dispatch = useDispatch();

	const onFetchMoodBoardProductImages = async () => {
		dispatch({
			type: Types.MOODBOARD_IMAGE_LOADING_START
		});
		await ApiClient.GET('moodboardAction', `${moodboardId}/product-image`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.ADD_IMAGES_FROM_RESPONSE_TO_MOODBOARD,
						payload: data
					});
					dispatch({
						type: Types.MOODBOARD_IMAGE_LOADING_CLOSE
					});
				}
			})
			.catch(({ response }) => {
				dispatch({
					type: Types.MOODBOARD_IMAGE_LOADING_CLOSE
				});
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onFetchMoodBoardColorResponse = async () => {
		dispatch({
			type: Types.MOODBOARD_COLOR_LOADING_START
		});
		await ApiClient.GET('moodboardAction', `${moodboardId}/colors`)
			.then(({ data }) => {
				if (data) {
					dispatch({
						type: Types.ADD_COLORS_FROM_RESPONSE_TO_MOODBOARD,
						payload: data
					});
					dispatch({
						type: Types.MOODBOARD_COLOR_LOADING_CLOSE
					});
				}
			})
			.catch(({ response }) => {
				dispatch({
					type: Types.MOODBOARD_COLOR_LOADING_CLOSE
				});
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onReUpload = async (image, id) => {
		dispatch(openLoader());
		await ApiClient.POST(
			'updateGroupDocument',
			{ ...image, id, extension: image.name.split('.').pop() },
			id
		)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.SET_REUPLOADED_MOODBOARD_IMAGE,
						payload: { docUrl: data.docUrl, id: id }
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onReUploadMoodboardImage = (image, id) => {
		dispatch({
			type: Types.SET_REUPLOADED_MOODBOARD_IMAGE,
			payload: { docUrl: image.base64Str, id }
		});
		onReUpload(image, id);
	};

	const onUploadFileToMoodboard = async (image) => {
		dispatch(openLoader());
		await ApiClient.POST('moodboardAction', image, `${moodboardId}/document`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.ADD_FILE_TO_MOODBOARD,
						payload: data.payload
					});
					onFetchMoodBoardProductImages();
					onFetchMoodBoardColorResponse();
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onDeleteMoodboard = async (docId) => {
		dispatch(openLoader());
		await ApiClient.DELETE('moodboardAction', {}, `${moodboardId}/image/${docId}`)
			.then(() => {
				dispatch(fetchMoodBoardDetails(moodboardId));
			})
			.finally(() => {
				dispatch(closeLoader());
			});
	};

	return (
		<div className="full-moodboard-image">
			{moodboardImageList?.length === 0 ? (
				<ImageUpload
					onUploadImage={(image) => onUploadFileToMoodboard(image)}
					docType={'PRESENTATION_MOOD_BOARD'}
					type={'imageAndPdf'}
					size="xl"
					imageSize={MOODBAOD_PRESENTATION_IMAGE_SIZE}
				/>
			) : (
				moodboardImageList?.map((item) => (
					<div className="full-moodboard-image" key={item.id}>
						<img src={item?.docUrl} alt="moodboard" />
						<div className="action-icons">
							<span>
								<ImageUpload
									onUploadImage={(image) => onReUploadMoodboardImage(image, item.id)}
									docType={'PRESENTATION_MOOD_BOARD'}
									isEditable={true}
									imageSize={MOODBAOD_PRESENTATION_IMAGE_SIZE}
									type={'imageAndPdf'}
								/>
							</span>
							<span>
								<ImageUpload
									onUploadImage={(image) => onUploadFileToMoodboard(image)}
									docType={'PRESENTATION_MOOD_BOARD'}
									type={'imageAndPdf'}
									isEditable={true}
									imageSize={MOODBAOD_PRESENTATION_IMAGE_SIZE}
									uploadIcon={`${process.env.PUBLIC_URL}/icons/plus-square.svg`}
								/>
							</span>
							<span>
								<img
									onClick={() => onDeleteMoodboard(item.id)}
									src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
								/>
							</span>
						</div>
					</div>
				))
			)}
		</div>
	);
};

export default MoodBoardItem;
